module.exports = __webpack_public_path__ + "media/images/icons/dropdown_black-365e6f95fee652519a4d29ce5314e6ca.svg";